import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["details", "chevron"]

  toggle() {
    if (this.hasDetailsTarget) {
      this.detailsTarget.classList.toggle("hidden")
    }
    if (this.hasChevronTarget) {
      this.chevronTarget.classList.toggle("rotate-90")
    }
  }
}
